import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CreateFolderContainer } from './create';
import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { selectFolder } from '../../actions/folders/actions';
import { unselectAll } from '../../actions/selected';
import { FoldersList } from '../../components/FoldersList';
import { addQueryToHistory, usePopstateEventQuery } from '../../hooks/browserHistory';
import { selectIsMapOpen } from '../../selectors';
import { selectCanLoadMore, selectFolders, selectSelectedId } from '../../selectors/folders';
import { getFolders } from '../../thunk/favorites';

export function FoldersListContainer() {
  const dispatch = useDispatch();
  const canLoadMore = useSelector(selectCanLoadMore);
  const folders = useSelector(selectFolders);
  const selectedFolderId = useSelector(selectSelectedId);
  const isMapOpen = useSelector(selectIsMapOpen);

  const handleLoadMoreClick = () => {
    dispatch(getFolders({ offset: folders.length, keepExisting: true }));
  };

  usePopstateEventQuery(queryParams => {
    // при открытой карте, остаемся в текущей папке, закрываем карту
    if (isMapOpen) {
      addQueryToHistory({ folder: `${selectedFolderId}` });
    }

    const folderIdToSet = (isMapOpen ? selectedFolderId : queryParams.folder) || null;
    const folder = (folderIdToSet && folders.find(folderItem => folderItem.id === +folderIdToSet)) || null;

    dispatch(selectFolder({ folder }));
    dispatch(unselectAll());
    dispatch(fetchFavoriteEntities({ offset: 0 }));
  });

  return (
    <FoldersList
      folders={folders}
      create={<CreateFolderContainer />}
      showLoadMoreButton={canLoadMore}
      onLoadMoreButtonClick={handleLoadMoreClick}
    />
  );
}
